import styled, { css } from 'styled-components';
import TextInput from '../TextInput';
import { withFlex, withMargins, withPaddings } from '../../mixins';
import Spinner from '../Spinner';
export const AutocompleteWrapper = styled.div `
  position: relative;
`;
export const Input = styled(TextInput) `
  .has-action-element {
    padding-right: 73px;
  }
`;
export const OptionsList = styled.ul `
  position: absolute;
  width: 100%;
  top: ${({ hasLabel }) => (hasLabel ? `72px` : `40px`)};
  overflow: auto;
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  left: 0px;
  background: var(--color-neutral-70);
  ${({ shadown }) => (shadown ? 'box-shadow: var(--shadow-level-12);' : '')};
  /* box-shadow: var(--shadow-level-12); */
  border-radius: var(--border-radius-sm);
  flex: none;
  order: 0;
  flex-grow: 0;
  z-index: var(--z-index-600-dropdown, 600);
`;
export const ResultItem = styled.li `
  width: 100%;
  ${withMargins}

  ${css `
    ${withPaddings}
  `}

  ${css `
    ${withFlex}
  `}
`;
export const LoadingIcon = styled(Spinner) `
  position: absolute;
  right: 16px;
  top: 16px;
  pointer-events: none;
`;
export const ActionElementWrapper = styled.div `
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  align-items: center;
  justify-content: flex-end;
`;
